import { render, staticRenderFns } from "./ChannelItem.vue?vue&type=template&id=564fc942&scoped=true&"
import script from "./ChannelItem.vue?vue&type=script&lang=js&"
export * from "./ChannelItem.vue?vue&type=script&lang=js&"
import style0 from "./ChannelItem.vue?vue&type=style&index=0&id=564fc942&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564fc942",
  null
  
)

export default component.exports